export default __webpack_public_path__ + "static/media/Fala poprzeczna.ebf9c5e8.png";